<template>
    <h5 v-if="scheduleStat.total" class="analytic-title">Статистика расписания: "{{ scheduleTitle }}"</h5>
    <div v-if="scheduleStat.total" class="analytic-items">
        <div class="select-period">
            <div class="select-period__items">
                <h5 class="select-period__items-title">Выбор отчётного периода</h5>
                <div class="controls">
                    <input :value="dateValue" @change="setDate" type="date" class="date" min="2022-01-01">
                    <select :value="periodValue" @change.prevent="setPeriod" class="selector">
                        <option value="" selected disabled>Период</option>
                        <option :value='op.value' v-for="op in options" :key="op.value">
                            {{ op.value }}
                        </option>
                    </select>
                </div>
                <div class="chart">
                    <Bar v-if="dashboardYData.length !== 0 && this.dashboardYData.every(el => el !== '0.0')"
                        id="my-chart-id"
                        :options="chartOptions"
                        :data="chartData"
                    />
                    <Bar v-else-if="dashboardYData.length === 0 || this.dashboardYData.every(el => el === '0.0')"
                        id="my-chart-id"
                        :options="chartOptions"
                        :data="chartData"
                        :plugins=[noData]
                    />
                </div>
            </div>
        </div>
    </div>
    <h5 class="analytic-title" v-else>Нет статистики по текущему расписанию</h5> 
</template>
<script>
import AnalyticsChart from '@/mixins/AnalyticsChart';

export default {
    name: 'ScheduleAnalytics',
    inject: ['schedulesAPI'],
    mixins: [AnalyticsChart],
    data:() => ({
        scheduleTitle: '',
        playerStat: [],
        playerIds: [],
        scheduleStat: [],
        filteredData: [],
        showEl: '',
        periodValue: '',
        dateValue: '',
        options: [
            { value: 'Вчера'},
            { value: 'Неделя'},
            { value: 'Месяц'},
            { value: 'Год'},
        ],
    }),
    props: ['id'],
    mounted() {
        this.getScheduleStat();
        this.getScheduleTitle();
  },
  unmounted(){
    this.playerStat = [];
    this.scheduleStat = [];
    this.scheduleTitle = [];
  },
  computed: {
        chartData() {
          return {
              labels: this.dashboardXData,
              datasets: [
              {
                  label:  'Время воспроизведения, ч.',
                  backgroundColor: ['#f87979', '#8AAE56', '#4287f5', '#4242f5', '#9191d9', '#bca1cf',  '#a155d4', '#bd62bd', '#cf4674', '#46b8cf', '#2ca397',
                  '#48c29f', '#84f5af', '#b2f7ad', '#d3f0b6', '#f5e449', '#f5ad49', '#f58349', '#b84c2e', '#730d0d'],
                  data: this.dashboardYData,
              }
              ]
              }
        }
      },
  methods: {
    show: function (index) {
        this.showEl = this.showEl === index ? null : index;
    },
    async getScheduleTitle(){
        try{
            const res = await fetch('/api/schedules/list');
            const data = await res.json();
            const currentSchedule = data.result.filter(d => d.id === parseInt(this.id));
            this.scheduleTitle = currentSchedule[0].name;
            console.log(this.scheduleTitle)

        }catch(e){
            console.log(e);
        }
    },
    async getScheduleStat(){
        try{
            const res = await fetch(`/api/statistics/schedule/${this.id}`)
            const data = await res.json();
            this.scheduleStat = data.result;
            this.playerIds = [Object.values(this.scheduleStat.sorted_by_players)[0]?.id]
            for (let i of this.playerIds){
                this.getPlayerStat(i)
            }
            }catch(e){
                console.log(e);
            }
    },
    async getPlayerStat(playerId){    
        try{
            const res = await fetch(`/api/statistics/player/${playerId}`)
            const data = await res.json();
            console.log(data)
            this.playerStat.push(data);
        }catch(e){
            console.log(e)
        }
    },
    async getScheduleMonthly(){
        try{
            const res = await fetch(`/api/statistics/schedule/${this.id}?period=this_month`)
            const data = await res.json();
            this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
            this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))
        }catch(e){
            console.log(e)
        }
    },
    async getScheduleDaily(){
        try{
            const res = await fetch(`/api/statistics/schedule/${this.id}?period=yesterday`)
            const data = await res.json();
            this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
            this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))
        }catch(e){
            console.log(e)
        }
    },
    async getScheduleYearly(){
        try{
            const res = await fetch(`/api/statistics/schedule/${this.id}?period=this_year`)
            const data = await res.json();
            this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
            this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))
        }catch(e){
            console.log(e)
        }
    },
    async getScheduleWeekly(){
        try{
            const res = await fetch(`/api/statistics/schedule/${this.id}?period=this_week`)
            const data = await res.json();
            this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
            this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))
        }catch(e){
            console.log(e)
        }
    },
    async getScheduleByDate(from, to){
        try{
            const res = await fetch(`/api/statistics/schedule/${this.id}?from=${from}&to=${to}`)
            const data = await res.json();
            this.dashboardXData = data.result.sorted_by_players.map(s => s.name)
            this.dashboardYData = data.result.sorted_by_players.map(s => (s.time/3600).toFixed(1))
        }catch(e){
            console.log(e)
        }
    },
    setPeriod(event){
        this.periodValue = event.target.value;
        this.dateValue = ''
        if (this.periodValue === 'Вчера'){
            this.getScheduleDaily();
        }else if(this.periodValue === 'Неделя'){
            this.getScheduleWeekly();
        }else if(this.periodValue === 'Месяц'){
            this.getScheduleMonthly();
        }else if(this.periodValue === 'Год'){
            this.getScheduleYearly();
        }
    },
    setDate(event){
        this.periodValue = '';
        this.dateValue = event.target.value;
        const from = Math.floor(new Date(event.target.value).getTime() / 1000);
        const nextDay = parseInt(event.target.value.split('-')[2])+1;
        let to = event.target.value.split('-');
        to.splice(2, 1);
        to.push(nextDay.toString());
        to = Math.floor(new Date(to).getTime() / 1000);
        this.getScheduleByDate(from, to)
    },
    timeFormat(seconds){
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const remainingSeconds = seconds % 60
        const resultString = `${hours<10 ? `0${hours}` : hours}:${minutes<10? `0${minutes}` : minutes}:${remainingSeconds<10? `0${remainingSeconds}`: remainingSeconds}`
        return  resultString;
    }
  },
}
</script>
<style scoped>
    .analytic-items{
        margin-top: 15px;
        display: flex;
        justify-content: center;
        max-width: 1200px;
        margin-left: auto;
        margin-right: auto;
    }
    .analytic-title{
        display: flex;
        justify-content: center;
        padding-top: 25px;
        padding-bottom: 25px;
        font-size: 28px;
        font-weight: normal;
}
    li{
        list-style-type: none;
    }
    .select-period__items{
        text-align: center;
    }
    .select-period__items-title{
        margin-top: 20px;
        font-size: 24px;
        margin-bottom: 40px;
    }
    .controls{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .date{
        width: 200px;
        height: 30px;
        padding: 20px;
        font-size: 18px;
        border: 2px solid teal;
        border-radius: 5px;
        margin-right: 25px;
        outline: none;
        cursor: pointer;
        transition: .3s all ease;
    }
    .date:focus{
        border: 2px solid rgb(2, 70, 70);
    }
    .selector{
        width: 130px;
        height: 43px;
        border-radius: 5px;
        padding-left: 15px;
        font-size: 18px;
        outline: none;
        background-color: transparent;
        border: 2px solid teal;
        cursor: pointer;
    }
    .chart{
        margin-top: 25px;
        width: 800px;
    }
    .active::after {
        transform: rotate(-90deg);
    }

    @media screen and (max-width: 1440px){
        .analytic-items{
            padding: 0 20px;
        }
    }
    @media screen and (max-width: 1280px){
        .analytic-title{
            max-width: 350px;
            margin: 0 auto;
            text-align: center;
        }
        .select-period__items{
            margin-left: auto;
            margin-right: auto;
        }
        .chart{
            width: 700px;
        }
    }
    @media screen and (max-width: 1024px){
        .chart{
            width: 600px;
        }
    }
    @media screen and (max-width: 900px) {
        .chart{
            width: 500px;
        }
    }
    @media screen and (max-width: 810px) {
        .chart{
            width: 450px;
        }
    }
    @media screen and (max-width: 768px){
        .chart{
            width: 400px;
            font-size: 0px;
        }
        .analytic-title h5{
            font-size: 26px;
            max-width: 300px;
        }
}
    @media  screen and (max-width: 700px) {
        .date{
            width: 190px;
        }
        .chart{
            width: 350px;
        }
    }
    @media  screen and (max-width: 640px) {
        .chart{
            width: 500px;
        }
    }
    @media  screen and (max-width: 520px) {
        .chart{
            width: 450px;
        }
    }
    @media  screen and (max-width: 480px) {
        .chart{
            width: 400px;
        }
    }
    @media  screen and (max-width: 420px) {
        .select-period__items-title {
            margin-top: 0px;
            margin-bottom: 30px;
        }
        .controls{
        flex-direction: column;
        align-items: center;
        }
        .date{
            margin-right: 0px;
            margin-bottom: 20px;
        }
        .date{
            width: 200px;
        }
        .selector{
            width: 200px;
        }
        .chart{
            width: 375px;
        }
    }
    @media  screen and (max-width: 380px){
        .chart{
            width: 350px;
        }
    }
    @media  screen and (max-width: 350px){
        .chart{
            width: 330px;
        }
    }
    @media  screen and (max-width: 330px){
        .chart{
            width: 315px;
        }
    }
</style>